import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import SvgImage from '@/components/Module/SvgImage';
import RedDot from '@/public/icons/record/red_dot.svg';
import usePlatform from '@/components/Record/hooks/usePlatform';

type P = {
  iconName: string;
  title: ReactNode;
  content: ReactNode;
  required?: boolean;
  rightContent?: ReactNode;
};

const DetailContent = ({
  iconName,
  title,
  content,
  required,
  rightContent,
}: P) => {
  const { isMobilePath } = usePlatform();
  const { i18n } = useTranslation();

  const getWidthByLanguage = () => {
    switch (i18n.language) {
      case 'en':
        return '156px';
      case 'zh':
        return '94px';
      case 'ko':
      default:
        return '86px';
    }
  };

  const width = getWidthByLanguage();
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '0px 8px',
        gap: isMobilePath ? '8px' : '12px',
        flexDirection: isMobilePath ? 'column' : 'row',
      }}
    >
      <div
        style={{
          display: 'flex',
          gap: '4px',
          color: 'var(--dk-text-secondary, #888D96)',
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '20px',
          alignItems: 'center',
          minWidth: width,
          width: width,
          boxSizing: 'content-box',
          minHeight: iconName === 'voice' ? '50px' : '30px',
          alignSelf: 'flex-start',
        }}
      >
        <div
          style={{
            display: 'flex',
            minWidth: '16px',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <SvgImage name={iconName} />
        </div>
        <div
          style={{
            position: 'relative',
          }}
        >
          {title}
          {required && (
            <RedDot style={{ position: 'absolute', right: '-6px' }} />
          )}
        </div>
      </div>
      <div
        style={{
          flexGrow: '1',
          width: '100%',
          position: 'relative',
          paddingLeft: isMobilePath ? '20px' : '',
        }}
      >
        {content}
      </div>
      {rightContent && (
        <div style={{ minWidth: '50px', height: '50px' }}>{rightContent}</div>
      )}
    </div>
  );
};

export default DetailContent;
